import { updatePage } from "./pageHistory";

// Saves the current state to the page the user is on
const updateCurrentPage = (state) => updatePage(state);

export default updateCurrentPage;
